import { createStore } from 'redux'

import { RootReducer, Actions } from './reducers'

export { Actions }
export type TRootReducer = ReturnType<typeof RootReducer>
export default createStore(RootReducer)
